import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {  Drawer, Radio, Space } from 'antd';
import FilterInput from "components/Form/filterInput"
import FilterSelect from "components/Form/filterSelect"
import {  useSelector } from 'react-redux';
import { genderOptions, maritalStatusOptions, leaveStatusOptions } from 'utils/constants';
import FilterDate from "components/Form/dateFilterInput"
import { Button } from 'components/Button';
import DateInput from 'components/Form/dateInput';
const FilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('right');  
   const {

    userData, userDataLoading,

} = useSelector((state) => state.common);


const [userDataOption, setUserDataOption] = useState([]);



useEffect(()=>{
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    setUserDataOption(_userData)  

},[userData])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
          if(key == "nationality"){
            return selectedValue.value
          }
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);


  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onChange = (e) => {
    setPlacement(e.target.value);
  };
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
        <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>
        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("reference_date")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "reference_date")}} 
        id="search" 
        label={"Reference date"} 
        />
        </div>

        <div className='col-12 mb-3' >
        <DateInput 
        selected={setFilterValue("posting_date")?.value}  
        onChange={e=>{handleDateChange(e.target.value, "posting_date")}} 
        id="search" 
        label={"Posting date"} 
        />
        </div>



        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "approval_status")}} optionLabel={"label"} optionValue={'value'} options={leaveStatusOptions} value={setFilterValue("approval_status")} placeholder={"Approval status"}/>
        </div>



     

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "current_approver")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("current_approver")} placeholder={"Current Approver"}/>
        </div>


        <div className="col-12">
    <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>

       
   
     </div>

      </Drawer>
    </>
  );
};
export default FilterDrawer;